var dealers;

$(document).ready(function(){
	var allVariants = [];
	var allPieces = [];
	var currentProductName='';
	if(typeof allVariantIds !== 'undefined'){
         getBuyNowData();
    }
	
	function getBuyNowData () {
       channelSightURL = window.environment.channelSightURL + '?source=MultipleSku&orderby=Name_Fixed&format=json' + '&brand=' + window.environment.brand + '&skulist=' + allVariantIds + '&countryCode=' + window.environment.countryCode ;
        $.ajax({
            type: "GET",
            url: channelSightURL,
			dataType : "json",
     		success: function (data) {
				  if(data.Status==="OK"  &&  typeof data.dealers !== 'undefined' && data.dealers.length>0)	      
	              {
					  var $ctrl=$('#buynowlink');
				       $ctrl.show(1000);
					   currentProductName=$ctrl.data('productname');
					   dealers=data.dealers;
				  }
			},
            error: function (error) {
		}
    });
  }


	function setPieceDropDownValueForStockStatus($pieceDropdownCtrl)
	{
		var options = $pieceDropdownCtrl.find('option');
		var optionToSelectFound = false;
		if(options.length > 1)
		{
			$(options).each(function(){
				var currentSku = $(this).val();
					var $currentOption = $(this);
					$(dealers).each(function(index,itemdata){
						$(itemdata.products).each( function(productIndex,productItemData){
								if(productItemData.sku === currentSku && productItemData.availability === "YES" )
								{
									optionToSelectFound = true;
									$currentOption.attr('selected','selected');
									return false;
								}
							});
						if(optionToSelectFound === true)
						{
							return false;
						}
					});
				if(optionToSelectFound === true)
				{
					return false;
				}
			});
		}
		if(optionToSelectFound === false && options.length > 0)
		{
			$(options).eq(0).attr('selected','selected')
		}
		$("#ddlBuyNowPieces").selectOrDie();
		$("#ddlBuyNowPieces").selectOrDie('update');
	}

if(typeof allVariantIds !== 'undefined'){
	$('#buynowlink').click(function(event){
	        event.preventDefault();
			var $pieceDropdownCtrl = $('#ddlBuyNowPieces');
			if($('#ddlBuyNowSizes').length === 0){
				if((typeof isBuyNowPieceCountDropdown !== 'undefined') && (isBuyNowPieceCountDropdown === "True") && $pieceDropdownCtrl.length !== 0) 
				{
				     setPieceDropDownValueForStockStatus($pieceDropdownCtrl);
					 bindDealerData($pieceDropdownCtrl.val());	
				}
				else
				{
				   bindDealerData();
				}
			}
			else  
			{
				if($('#ddlBuyNowSizes').val() === "0")
				{
					showMessage(window.labels.selectSizeForRetailer);	
				}
				else 
				{
					if((typeof isBuyNowPieceCountDropdown !== 'undefined') && (isBuyNowPieceCountDropdown === "True") && $pieceDropdownCtrl.length !== 0) 
					{
					   bindDealerData($pieceDropdownCtrl.val());	
				    }
				    else
				    {
				      bindDealerData($('#ddlBuyNowSizes').val());
				    }
				}
			}	
	});
}
	$('#ddlBuyNowSizes').change(function(){
		var selectedOption = $(this).val();
		var $pieceDropdownCtrl = $('#ddlBuyNowPieces');
		$('.selectProduct-sizeWrap').removeClass('hide');
		if(selectedOption === "0")
		{
			$("#ddlBuyNowPieces").selectOrDie('destroy');
			showMessage(window.labels.selectSizeForRetailer);
			$pieceDropdownCtrl.children('option').remove();
			if($pieceDropdownCtrl.length > 0)
			{
				    $pieceDropdownCtrl.addClass('hide');
			}
			$('div#dealersConatiner').html('');
		}
		else
		{
		        if((typeof isBuyNowPieceCountDropdown !== 'undefined') && (isBuyNowPieceCountDropdown === "True") && $pieceDropdownCtrl.length !== 0) {
					$pieceDropdownCtrl.children('option').remove();
					$pieceDropdownCtrl.removeClass('hide');
		     	    var allVariantIdArray=allVariantIds.split(',');
				    var allPieceCountsArray=allPieceCounts.split(',');
					var processedSizes = [];
					var optionList = '';
					$(selectedOption.split(',')).each(function(index,currentVariantId){
					var currentVariantIdIndex = $.inArray(currentVariantId,allVariantIdArray);
					if(currentVariantIdIndex > -1)
					{
						var pieceCountCaption = allPieceCountsArray[currentVariantIdIndex];
						if(!isNaN(pieceCountCaption))
						{
							var pieceCount=parseInt(pieceCountCaption);
							if($.inArray(pieceCount,processedSizes) === -1)
							{
								processedSizes.push(pieceCount);
								if(optionList === '')
								{
									optionList = pieceCountCaption + "|" + currentVariantId;
								}
								else
								{
									optionList = optionList + "-" + pieceCountCaption + "|" + currentVariantId;
								}
							}
							else
							{
								var optionListForTraversel = optionList.split('-');
								$(optionListForTraversel).each(function(index,currentItem){
									var currentOptionParts = currentItem.split('|');
									if(currentOptionParts[0] === pieceCountCaption && currentOptionParts[1] !== undefined)
									{
										var existingValue = pieceCountCaption + "|" + currentOptionParts[1];
										var newValue = existingValue + ',' + currentVariantId;
										optionList=optionList.replace(existingValue,newValue);
									}
								});
							}
						}
					}
				});
				processedSizes.sort((a, b) => a - b);
				var spliitedOptionArray = optionList.split("-");
				$(processedSizes).each(function(index,item){
					$(spliitedOptionArray).each(function(innerIndex,innerItem){
						if(innerItem.indexOf(item + "|") === 0)
						{	
							var currentValue = innerItem.split('|')[1];
							$pieceDropdownCtrl.append('<option value="' + currentValue + '">' + item + window.labels.piecesLabel + '</option>');
						}
					});
				});
				 setPieceDropDownValueForStockStatus($pieceDropdownCtrl);
				 bindDealerData($pieceDropdownCtrl.val());
				}
			else
			{
				bindDealerData(selectedOption);
		    }
		}
	});
	
	$('#ddlBuyNowPieces').change(function(){
		bindDealerData($(this).val());
	});
	
	function showMessage(message)
	{
	   var $messageContainer = $('div.messageInfo-wrap');
	   if($messageContainer.length > 0)
	   {
			$messageContainer.removeClass('hide');
			var $messageField=$messageContainer.find('p.messageInfo');
			$messageField.text(message);
       }		
	}
	
	function bindDealerData(selectedSKUs)
	{
		allVariants = allVariantIds.split(',');
		allPieces = allPieceCounts.split(',');
		var passedSKUs = [];
		if(selectedSKUs !== undefined )
		{
			passedSKUs = selectedSKUs.split(',');           
		}
		var $html = $('<div></div>').html('');
		var $packInfoHTML = $('<div></div>').html('');
		$(dealers).each(function(index,itemdata){
			$packInfoHTML.html('');
			$(itemdata.products).each( function(productIndex,productItemData){
				var buyNowCaption = window.labels.outOfStock;
				var $buyNowButtonHTML = $('<span class="u-btnBuy status-outofStock btn"></span>').text(buyNowCaption);
				if( passedSKUs.length === 0 ||  ($.inArray(productItemData.sku,passedSKUs) > -1) )
				{
					var pieceInfo = '';
					var currentSKUIndex = $.inArray(productItemData.sku,allVariants );
					if(currentSKUIndex > -1)
					{
						pieceInfo = allPieces[currentSKUIndex] + window.labels.piecesLabel;
					}
					if(productItemData.availability === "YES")
					{
						buyNowCaption = window.labels.buyNow;
						$buyNowButtonHTML = $('<a target="_blank" class="u-btnBuy statusAvailable btn' + ' " onclick="fireAnalytics(this)"></a>').text(buyNowCaption);
						$buyNowButtonHTML.attr('href',productItemData["buy-url"]);
						$buyNowButtonHTML.attr('data-siteurl',itemdata['site-url']);
						$buyNowButtonHTML.attr('data-productname',currentProductName);
					}	
					var imageClass = '';
					if($packInfoHTML.html() !== '')
					{
						$packInfoHTML.html($packInfoHTML.html().replace('showBorder','hideBorder'));  
						imageClass = 'show-sm hide';
					}
					var $img=$('<img class="productVendor-img ' + imageClass + '">');
					$img.attr('src',itemdata['logo-url']);
					$img.attr('alt',itemdata['name']);
					$packInfoRowContainerHTML = $('<div class="row productInfo-Details showBorder"></div>');
					if((typeof isBuyNowPieceCountDropdown !== 'undefined') && isBuyNowPieceCountDropdown === "True") 
					{
						$packInfoRowContainerHTML.append($('<div class="productVendor-wrap col-2 col-xs-3"> </div>').prepend($img));
						$packInfoRowContainerHTML.append($('<div class="productCount-wrap col-5 col-md-5 col-xs-4"></div>').text(itemdata['name']));
						var priceValue = productItemData["price"];
						if (typeof window.labels.currencySymbol !== 'undefined')
						{
							priceValue = priceValue + ' ' + window.labels.currencySymbol;
						}
						$packInfoRowContainerHTML.append($('<div class="productCount-wrap col-2 col-md-2 col-xs-4"></div>').text(priceValue));
					}
					else
					{
						$packInfoRowContainerHTML.append($('<div class="productVendor-wrap col-7 col-md-7 col-xs-6"> </div>').prepend($img));
						$packInfoRowContainerHTML.append($('<div class="productCount-wrap col-2 col-md-2 col-xs-6 "></div>').text(pieceInfo));
				    }
					$packInfoRowContainerHTML.append($('<div class="productStatus-wrap col-3 col-md-3 col-xs-12 "></div>').append($buyNowButtonHTML));	
					$packInfoHTML.append($packInfoRowContainerHTML);
				}
			});
			if($packInfoHTML.html() !== '')
			{
				$html.append($packInfoHTML.html());
			}
		}); 
		if($html.html() !== '')
		{
			if((typeof isBuyNowPieceCountDropdown !== 'undefined') && isBuyNowPieceCountDropdown === "True") 
			{
				$html.prepend($('<div class="row"><div class="col-2 col-xs-3"></div><div class="col-7 col-md-7 col-xs-4 u-rowTitle"></div><div class="col-3"></div></div>'));
				$html.append($('<div class="row"><p class="disclaimerInfo">'+ window.labels.disclaimerInfo +'</p></div>'));
			}
			else
			{
				$html.prepend($('<div class="row"><div class="col-7 col-md-7 col-xs-6"></div><div class="col-2 col-md-2 col-xs-6 u-rowTitle">'+ window.labels.packCount+'</div><div class="col-3"></div></div>'));
			}
			$('div#dealersConatiner').html($html.html());
			var $messageContainer= $('div.messageInfo-wrap');
			if($messageContainer.length > 0)
			{
				$messageContainer.addClass('hide');
			}		
		}
		else
		{
			$('div#dealersConatiner').html('');
			showMessage(window.labels.noProductForRetailer);
		}
	}
	
});
function fireAnalytics(ctrl)
	{
		var $currentctrl=$(ctrl);
		var productName=$currentctrl.data('productname');
		dataLayer.push({
        'event': 'gaEvent',
      	'eventTrigger': 'buyNowClick',
        'eventCategory': 'Buy Now - Retailer Click - Retailer Domain',
        'eventAction': productName, 
        'eventLabel': $currentctrl.data('siteurl'), 
        'eventValue': undefined
		});

	dataLayer.push({
        'event': 'gaEvent',
      	'eventTrigger': 'buyNowClick',
        'eventCategory': 'Buy Now - Retailer Click - Page URL',
        'eventAction': productName,
        'eventLabel': window.location, 
        'eventValue': undefined
		});
		
	}